import { createApp } from 'vue/dist/vue.esm-bundler.js'
{
  const appConfig = {
    compilerOptions: {
      // register any non-vue custom elements we can use inside this app
      isCustomElement: (tag) => ["ada-toggler" ].includes(tag),
    },    
    props: [
      'el'
    ],
    data(){
      return {

        foundLocations: [],

        // localized data
        locations: window.locationFinder.locations,
        googleMapsAPIKey: window.locationFinder.googleMapsAPIKey,

        // app data
        searchType: 'geolocation', // geolocation|zip - how should the users latitude/longitude be determined? 
        zip: null,
        radius: 10,
        // filters: [],

        // data to manage the app state
        searchIsDirty : false,
        latitude: null,
        longitude: null,
        loading: false,
        ariaAnnouncement: '',
      }
    },
    mounted(){
      // nothing to do
    },
    computed: {
      currentDay() {
        return new Date().toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
      }
    },
    methods: {
      // sets latitude/longitude by the users zip using google api, then runs the search
      setLatLongByZip(){

        this.loading = true
        fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${this.zip}&key=${this.googleMapsAPIKey}`)
          .then((response) => response.json())
          .then((data) => {
            this.loading = false
            if (data.status === 'OK' && data.results.length > 0) {
              const location = data.results[0].geometry.location
              this.latitude = location.lat
              this.longitude = location.lng
              this.sortAndFilter()
            } else {
              alert('Geocoding for the provided zip code was not successful.')
            }
          })
          .catch((error) => {
            this.loading = false
            alert('Error occurred while fetching geocoding data:', error)
          })
       },
      // filters/sorts all service pros - 
      sortAndFilter(){
        let cleanPosts = [ ... this.locations ]

        //only accept locations with valid lag/lng
        cleanPosts = cleanPosts.filter(post => post.acf.location_map.lat && post.acf.location_map.lng)

        // clean up data to make these easier to use
        cleanPosts.map(post => {
          // find distance from the user
          post.distance = this.haversineDistance(this.latitude, this.longitude, post.acf.location_map.lat, post.acf.location_map.lng)
        })

        //remove locations too far away
        cleanPosts = cleanPosts.filter(post => post.distance <= parseFloat(this.radius))

        cleanPosts = cleanPosts.sort((a,b) => parseFloat(a.distance) > parseFloat(b.distance) ? 1 : -1)
        this.foundLocations = cleanPosts
        this.searchIsDirty = true
        this.$nextTick( () => {
          this.setAria()
        })
      },
      setAria() {
        if(this.foundLocations.length) {
          this.ariaAnnouncement = 'Showing '+ this.foundLocations.length+ ' of ' + this.locations.length + ' Locations'
        }
        this.$nextTick( () => {
          document.querySelector('#job-listings-search--announcement').focus()
        })
      },
      degToRad(degrees) {
        return degrees * (Math.PI / 180)
      },
      haversineDistance(lat1, lon1, lat2, lon2) {
        const earthRadiusKm = 3958.8 // Radius of the Earth in miles

        const dLat = this.degToRad(lat2 - lat1)
        const dLon = this.degToRad(lon2 - lon1)

        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.degToRad(lat1)) * Math.cos(this.degToRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

        const distance = earthRadiusKm * c
        return parseFloat(distance).toFixed(2)
      },
      enableFormMode(storeEmail, storeNearBy) {
        document.querySelector('.job-listings-search').style.display = 'none'
        document.querySelector('#job-listings-search--form-wrapper').style.display = 'block'
        document.querySelector('#job-listings-search--form-wrapper .store_listings_form').style.display = 'block'
        document.querySelector('#job-listings-search--form-wrapper-nearby').innerHTML = storeNearBy
        document.querySelector('input#input_3_28').setAttribute('value', storeEmail)
        document.querySelector('#job-listings-search--form-wrapper--announcement').focus()
      }

    }
  }

  function initApp(){
    const els = document.querySelectorAll('.job-listings-search')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig, { el })
        app.mount(el)
      })
    }
  }

  initApp()
}